import React, { useState } from 'react';
import Styles from './CDCProtegido25Protecao.css';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CustomEmblaCarouselHome24 from '../CustomEmblaCarouselHome24';
function CDCProtegido25Protecao() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="cdc-protecao">
        <ContainerHome24>
          <div className="protecao-contain">
            <div className="protecao-titulos">
              <h2 className="protecao-titulo">Proteção adicional para você e sua família</h2>
              <p className="protecao-texto">
                Fique mais tranquilo sabendo que pode ter apoio no caso de algum imprevisto
                financeiro.
              </p>
            </div>
            <div className="protecao-conteudos">
              <img src="assets/cdc25/protecao/img-protecao.svg" alt="" className="img-protecao" />
              {typeof window === 'undefined' ? (
                <></>
              ) : (
                <>
                  {width < 992 && (
                    <div className="carrossel-protecao">
                      <CustomEmblaCarouselHome24 enableBullets enableMobileArrows detectBulletCount>
                        {({ className }) => (
                          <>
                            <div className={`slide ${className}`}>
                              <img src="assets/cdc25/protecao/ic_civil_liability.svg" alt="" />
                              <p className="carrossel-protecao-texto">
                                Inclua o valor de seu seguro no financiamento de seu veículo.
                              </p>
                            </div>
                            <div className={`slide ${className}`}>
                              <img src="assets/cdc25/protecao/ic_std_people.svg" alt="" />
                              <p className="carrossel-protecao-texto">
                                Conte com nossa proteção contra*
                                <br />
                                • Morte
                                <br />• Invalidez
                                <br />• Desemprego
                              </p>
                            </div>
                            <div className={`slide ${className}`}>
                              <img src="assets/cdc25/protecao/ic_bank_credit.svg" alt="" />
                              <p className="carrossel-protecao-texto">
                                Sorteios mensais
                                <br /> de R$ 50 mil
                              </p>
                            </div>
                            <div className={`slide ${className}`}>
                              <img src="assets/cdc25/protecao/ic_internet_banking.svg" alt="" />
                              <p className="carrossel-protecao-texto">
                                Acompanhe através <br />
                                das plataformas digitais
                              </p>
                            </div>
                          </>
                        )}
                      </CustomEmblaCarouselHome24>
                    </div>
                  )}
                  {width >= 992 && (
                    <div className="cards-protecao">
                      <div className="card-protecao card-menor">
                        <img src="assets/cdc25/protecao/ic_civil_liability.svg" alt="" />
                        <p className="card-protecao-texto">
                          Inclua o valor de seu seguro no financiamento de seu veículo.
                        </p>
                      </div>
                      <div className="card-protecao card-menor">
                        <img src="assets/cdc25/protecao/ic_bank_credit.svg" alt="" />
                        <p className="card-protecao-texto">
                          Sorteios mensais
                          <br /> de R$ 50 mil
                        </p>
                      </div>
                      <div className="card-protecao">
                        <img src="assets/cdc25/protecao/ic_std_people.svg" alt="" />
                        <p className="card-protecao-texto">
                          Conte com nossa proteção contra*
                          <br />
                          • Morte
                          <br />• Invalidez
                          <br />• Desemprego
                        </p>
                      </div>
                      <div className="card-protecao card-menor">
                        <img src="assets/cdc25/protecao/ic_internet_banking.svg" alt="" />
                        <p className="card-protecao-texto">
                          Acompanhe através <br />
                          das plataformas digitais
                        </p>
                      </div>
                    </div>
                  )}
                </>
              )}
            </div>
          </div>
          <p className="protecao-disclaimer">*Conforme produto contratado</p>
        </ContainerHome24>
      </section>
      {typeof window === 'undefined' ? (
        <></>
      ) : (
        <>
          {width <= 500 && (
            <picture>
              <source type="image/webp" srcSet="assets/cdc25/separador-cdc.webp" />
              <source type="image/jpg" srcSet="assets/cdc25/separador-cdc.jpg" />
              <img
                src="assets/cdc25/separador-cdc.jpg"
                alt="Pessoa assinando contrato ao lado de um carro em miniatura e chave, simbolizando proteção financeira e segurança para você e sua família com seguro Santander Financiamentos."
                className="emp-garantia-carro-img-separacao"
              />
            </picture>
          )}
          {width > 500 && (
            <picture>
              <source type="image/webp" srcSet="assets/cdc25/separador-cdc-desk.webp" />
              <source type="image/jpg" srcSet="assets/cdc25/separador-cdc-desk.jpg" />
              <img
                src="assets/cdc25/separador-cdc-desk.jpg"
                alt="Pessoa assinando contrato ao lado de um carro em miniatura e chave, simbolizando proteção financeira e segurança para você e sua família com seguro Santander Financiamentos."
                className="emp-garantia-carro-img-separacao"
              />
            </picture>
          )}
        </>
      )}
      <style jsx>{Styles}</style>
    </>
  );
}

export default CDCProtegido25Protecao;
